import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import {
  FormGroup,
  Label,
} from 'reactstrap';

class SearchableSelect extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    isSearchable: PropTypes.bool,
    isClearable: PropTypes.bool,
    groupClass: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
      warning: PropTypes.string,
    }),
  }

  static defaultProps = {
    label: '',
    disabled: false,
    isSearchable: true,
    isClearable: false,
    groupClass: '',
    data: [],
    meta: {
      touched: false,
      error: '',
      warning: '',
    },
  }

  handleChange = (item) => {
    const { value } = item || {};
    this.props.input.onChange(value || '');
  }

  render() {
    const {
      label,
      disabled,
      groupClass,
      isSearchable,
      isClearable,
      data,
      defaultValue,
      meta: { touched, error, warning },
    } = this.props;

    return (
      <FormGroup className={groupClass}>
        {!isEmpty(label) ? (
          <Label>
            {label}
          </Label>
        ) : null}
        <Select
          options={data}
          isSearchable={isSearchable}
          onChange={this.handleChange}
          className={classNames('', {
            'is-invalid': touched && !isEmpty(error),
          })}
          isDisabled={disabled}
          value={defaultValue}
          isClearable={isClearable}
        />
        {touched && ((!isEmpty(error) && <small className="invalid-feedback" style={{ display: 'block' }}>{error}</small>) || (warning && <span>{warning}</span>))}
      </FormGroup>
    );
  }
}

export default SearchableSelect;
